import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Grid,
    Button,
    Select,
    MenuItem,
    Divider,
    Paper,
    usePagination,
    TextField,
    InputAdornment,
    ClickAwayListener,
    Collapse,
    Checkbox,
    Autocomplete,
    Typography,
    Card,
    Avatar,
    CardContent
} from "@mui/material";
import CircularProgress, {
    circularProgressClasses,
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams, useLocation } from "react-router-dom";
import React, { useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import Search from "@mui/icons-material/Search";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import { ReactComponent as HistoryLF } from "../../../../assets/icons/historyLF.svg";
import { ReactComponent as Preview } from "../../../../assets/icons/preview.svg";
import { ReactComponent as LaunchFormIcon } from "../../../../assets/icons/launchForm.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as IconXsearch } from "../../../../assets/icons/iconXsearch.svg";
import { ReactComponent as CloseIconLF } from "../../../../assets/icons/closeIconLF.svg";
import * as Util from "../../../../services/global.service";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import debounce from 'lodash.debounce';
import { useFormik } from 'formik';
import * as yup from 'yup';
import evaluation360Service from "../../../../services/360Evaluation.service";
import { width } from "@mui/system";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg";
import { ReactComponent as FormIcon } from "../../../../assets/icons/form360.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { ReactComponent as TeamIcon } from "../../../../assets/images/people.svg";
import { ReactComponent as InnovationIcon } from "../../../../assets/images/position-icon.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    flexPaper: {
        flex: 1,
        minWidth: 350,
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        borderRadius: "10px !important        "
    },
    fillBlack: {
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap',
        marginTop: "30px"
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#343A40",
        color: "#FFFFFF",
        padding: "11px 15px",
        fontSize: "14px"
    },
}));

const AddEvaluator = () => {
    let { serial } = useParams()
    const classes = useStyles();
    const { state } = useLocation();
    let { type } = useParams();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [open, setOpen] = React.useState(false);
    let [cycle, setCycle] = React.useState([]);
    let [list, setList] = React.useState([]);
    const navigate = useNavigate();
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [targetGroups, setTargetGroups] = React.useState([]);
    const [dataFilter, setDataFilter] = React.useState({});
    const [selected, setSelected] = React.useState([]);
    const [search, setSearchValue] = React.useState("");
    const [oldDataFilter, setOldDataFilter] = React.useState({});
    const [showLoading, setShowLoading] = React.useState(false);
    const [openLaunchForm, setOpenLaunchForm] = React.useState(false);
    const [focusSearch, openFocusSearch] = React.useState(false);
    const [selectSearch, setSelectSearch] = React.useState([]);
    const [datePosition, setDatePosition] = React.useState("");
    const [dateEmpoloyee, setDateEmpoloyee] = React.useState("");
    const [dataSerial, setDataSerial] = React.useState([]);
    const language = localStorage.getItem("lang");
    const [errorText, seterrorText] = React.useState("");

    const setDateWork = () => {
        if (Util.formatData(state?.data?.candidate?.pos_exp, false) !== false && Util.formatData(state?.data?.candidate?.pos_exp, false) !== false) {
            let dataPositionDate = state?.data?.candidate?.pos_exp
            let dataEmpolyeeDate = state?.data?.candidate?.emp_exp
            if (language === "en-US") {
                dataPositionDate = dataPositionDate.replace('y', 'y ')
                dataPositionDate = dataPositionDate.replace('m', 'm ')
                // dataPositionDate = dataPositionDate.replace('d', 'd ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', 'y ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', 'm ')
                // dataEmpolyeeDate = dataEmpolyeeDate.replace('d', 'd ')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            } else {
                dataPositionDate = dataPositionDate.replace('y', ' ปี ')
                dataPositionDate = dataPositionDate.replace('m', ' เดือน ')
                dataPositionDate = dataPositionDate.replace('d', ' วัน')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', ' ปี ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', ' เดือน ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('d', ' วัน')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            }

        }
    }
    useEffect(() => {
        setDateWork()
    }, [state.data]);
    useEffect(() => {
        let datas = []
        for (let idx = 0; idx <= state?.data?.template_evaluator.length - 1; idx++) {
            console.log(state?.data?.template_evaluator[idx].form_evaluator, 7);
            if (Util.formatData(state?.data?.template_evaluator[idx].form_evaluator, false) !== false) {
                for (let index = 0; index <= state?.data?.template_evaluator[idx]?.form_evaluator.length - 1; index++) {
                    datas.push(state?.data?.template_evaluator[idx]?.form_evaluator[index].employee.serial)
                }
            }
        }
        setDataSerial(datas)
    }, []);
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        descriptionEN: yup.string().max(1000).required(t('admin.inputForm.msgError.nameTH')),
        competencyType: yup.string().max(255).required(t('admin.inputForm.msgError.plessSelect')),
        ratingScaleMaster: yup.string().max(255).required(t('admin.inputForm.msgError.plessSelect')),
    });
    const formik = useFormik({
        initialValues: {
            word: "",
            employees: [],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
        },
    });

    const handleClose = (event) => {
        let dataSet = selected.map(a => a?.id)
        setSelectSearch([])
        openFocusSearch(false)
        setMainItems(selected)
        setItems(selected)
        formik.setFieldValue("employees", dataSet)
        if (Util.formatData(document.getElementById('searchEmployee'), false) !== false) {
            document.getElementById('searchEmployee').value = ""
        }
    };

    const handleFocus = () => {
        openFocusSearch(true)

    };

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return items
            .slice(firstPageIndex, lastPageIndex);
    }, [items, currentPage, perPage]);

    let closeLaunchForm = () => {
        setOpenLaunchForm(false)
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };

    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };

    const handleTotalPage = () => {
        const List = items
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };

    useEffect(() => {
        handleTotalPage();
    }, [items, perPage]);

    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            currentData.sort(function (b, a) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            currentData.sort(function (a, b) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }

    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    useEffect(() => {
        dataSerachs(mainItems)
    }, [search]);

    const dataSerachs = async (data, type) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'organization' || key === "position" || key === "position_type") {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'name') {
                        let checkName = false;
                        if (rs[key].en !== undefined && rs[key].en.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        if (rs[key].th !== undefined && rs[key].th.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        return checkName;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        await setItems(result);
    };

    // const [query, setQuery] = React.useState("");

    const changeHandler = event => {
        // setQuery(event.target.value);
        if (event.target.value.length > 2) {
            getDataFilter(event.target.value,)
        }
    };
    const debouncedChangeHandler = useCallback(
        debounce(changeHandler, 500), console.log()
        , []);

    let getDataFilter = (text) => {
        let data = {
            word: text,
            exclude: Util.formatData(dataSerial, []).length > 0 ? dataSerial : [],
            require_info: true,
        }
        evaluation360Service.getListSearchEmployee(data).then((rs) => {
            setOldDataFilter(data)
            setSelectSearch(Util.formatData(rs?.data?.employees, []))
        }).catch((error) => {

        })
    }

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    let handleDirect = async () => {
        formik.setFieldValue("employees", [])
        setSelectSearch([])
        setSelected([])
        setMainItems([])
        setItems([])
        openSuccessAddDialog(false)
        navigate(`/kpi/360evaluation/manage/${state?.data?.form_evaluate_id}`, { replace: false });
    }

    const handleClick = (data) => {
        const selectedIndex = selected.indexOf(data);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const handleClickAll = () => {
        let newSelected = [...selected];
        if (checkAll() === true) {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = newSelected.filter((rs) => rs?.id !== selectSearch[index]?.id)
                newSelected = dtFilter
            }
            setSelected(newSelected);
        } else {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = newSelected.filter((rs) => rs?.id === selectSearch[index]?.id)
                if (dtFilter.length <= 0) {
                    newSelected.push(selectSearch[index])
                }
            }
            setSelected(newSelected);
        }
    };

    let checkSelect = (data) => {
        let check = false
        let checkFilterData = selected.filter((rs) => rs?.id === data)
        if (checkFilterData.length > 0) {
            check = true
        }
        return check
    }

    let checkAll = () => {
        let selectAll = true
        if (selectSearch.length > 0) {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = selected.filter((rs) => rs?.id === selectSearch[index]?.id)
                if (dtFilter.length <= 0) {
                    selectAll = false
                }
            }
        } else {
            selectAll = false
        }
        return selectAll
    }

    let checkIndeterminate = () => {
        let selectTrue = []
        let selectFalse = []
        if (selectSearch.length > 0) {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = selected.filter((rs) => rs?.id === selectSearch[index]?.id)
                if (dtFilter.length > 0) {
                    selectTrue.push("1")
                } else {
                    selectFalse.push("1")
                }
            }
            if (selectTrue.length > 0 && selectFalse.length > 0) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const clearAll = () => {
        setSelected([])
        formik.setFieldValue("employees", [])
        setMainItems([])
        setItems([])
    }
    let clearOne = (data) => {
        const selectedIndex = selected.indexOf(data);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
        setMainItems(newSelected)
        setItems(newSelected)
        let dataSet = newSelected.map(a => a?.id)
        formik.setFieldValue("employees", dataSet)
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate(`/kpi/360evaluation/manage/${state?.data?.form_evaluate_id}`, { replace: false });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const submit = (data) => {
        let dataSelected = []
        for (let idx = 0; idx <= selected?.length - 1; idx++) {
            dataSelected.push(selected[idx]?.id)
        }
        let dataMain = {
            "form_evaluate_id": state?.data?.form_evaluate_id,
            "remark": "",
            "template_evaluator": {
            }
        }
        dataMain.template_evaluator[state.dataEmployee.type] = dataSelected
        evaluation360Service.addEvaluator(dataMain).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            seterrorText(t(`360Evaluation.label.addEvaluatorFail`))
            handleOpenFailedMessageDialog(true)
        })
    }
    return (
        <Box style={{ maxHeight: "100%", overflowY: "auto" }}>
            <Box id="back-to-top-anchor"> </Box>
            <Helmet>
                <title>Add Evaluators | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={styles.link} onClick={() => clickLink('/kpi/home')}>
                                {t('label.home')}
                            </span> /
                            {state?.data?.editor === "manager" ?
                                <span style={styles.link} onClick={() => clickLink(`/kpi/360evaluation-manager`)}>
                                    {` ${t("360Evaluation.label.Manage360Evaluation")} `}
                                </span>
                                :
                                <span style={styles.link} onClick={() => clickLink(`/kpi/my360evaluation`)}>
                                    {` ${t("sidebar.label.my360evaluation")} `}
                                </span>
                            }
                            /
                            <span style={styles.link} onClick={() => clickLink(`/kpi/360evaluation/manage/${state?.data?.form_evaluate_id}`)}>
                                {` ${t("360Evaluation.label.360Evaluation")}`}
                            </span> /
                            <span style={styles.end} >
                                {` ${t("360Evaluation.label.addEvaluators")}`}
                            </span>
                        </Typography>
                    </Grid>
                    <Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" fontWeight={600} >
                                {` ${t("360Evaluation.label.addEvaluators")}`}
                            </Typography>
                        </Box>
                        <Grid container item pb={2} pt={2}>
                            <Grid item xs sm md lg>
                                <Card sx={{ p: "40px", height: 1, "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)", "border-radius": "10px" }}>
                                    <CardContent sx={{ p: "0!important" }}>
                                        <Grid container>
                                            <Grid item lg={12} xs={12} display="flex" >
                                                <Grid item xs={6} display="flex" flexDirection="column" pr="15px">
                                                    <Typography variant="h3" fontWeight={600} color="#404349">
                                                        {state?.data?.editor === "evaluator" ?
                                                            state?.data?.form !== undefined && state?.data?.form !== null ?
                                                                state?.data?.form?.name
                                                                : null
                                                            :
                                                            t('evaluation.evaluationInformation')
                                                        }
                                                    </Typography>
                                                    <Grid container mt={2} display="flex" alignItems="center">
                                                        <Grid item display="flex" alignItems="center" mr="10px">
                                                            <FormIcon class={`${classes.fillBlack}`}></FormIcon>
                                                        </Grid>
                                                        <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                            <Box >
                                                                <Typography fontSize={18} lineHeight={1.1} color="#404349" fontWeight="500">
                                                                    {t('evaluation.formNameManage360')}: <span style={{ fontWeight: "400" }}>{Util.formatData(state?.data?.form?.name, "-")}</span>
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container mt={2} display="flex" alignItems="center">
                                                        <Grid item display="flex" alignItems="center" mr="10px">
                                                            <CalendarIcon class={`${classes.fillBlack}`}></CalendarIcon>
                                                        </Grid>
                                                        <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                            <Box >
                                                                <Typography fontSize={18} lineHeight={1.1} color="#404349" fontWeight="500">
                                                                    {t('evaluation.dueDateManage')}: <span style={{ fontWeight: "400" }}>{Util.dateDayFormat(state?.data?.due_date)}</span>
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} display="flex" flexDirection="column" pl="15px">
                                                    <Typography fontSize={14} lineHeight="24px" fontWeight={500} color="#AAAAAA">
                                                        {t('evaluation.candidateProfile')}
                                                    </Typography>
                                                    <Grid container display="flex" alignItems="flex-start" flexDirection="row">
                                                        <Grid
                                                            item
                                                            display="flex"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            mr={3}
                                                        >
                                                            <Avatar
                                                                src={state?.data?.candidate?.photo}
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    width: 50,
                                                                    height: 50,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs sm md lg>
                                                            <Grid container mb="3px" display="flex" alignItems="center" justifyContent="space-between">
                                                                <Grid item >
                                                                    <Typography fontSize={20} lineHeight="24px" fontWeight={600} color="primary">
                                                                        {Util.formatData(state?.data?.candidate?.fullname, "-")}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container>
                                                                <Grid item xs sm md lg={12} display="flex" alignItems="center" >
                                                                    <Box display="flex" flexDirection="column" justifyContent="center">
                                                                        <Box display="flex" alignItems="center" pt="5px">
                                                                            <BootstrapTooltip title={t(`label.position`)} placement="top">
                                                                                <InnovationIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></InnovationIcon>
                                                                            </BootstrapTooltip>
                                                                            <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.formatData(state?.data?.candidate?.position, "-")} ({Util.formatData(datePosition, t('label.dateWork'))})</Typography>
                                                                        </Box>
                                                                        <Box display="flex" alignItems="center" pt="5px">
                                                                            <BootstrapTooltip title={t(`label.team`)} placement="top">
                                                                                <TeamIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></TeamIcon>
                                                                            </BootstrapTooltip>
                                                                            <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.formatData(state?.data?.candidate?.organization, "-")}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <Box sx={{ background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", }} p="20px 40px 25px" mt="20px">
                            <Box sx={{ margin: "0 -40px", display: "flex", flexFlow: "row wrap" }}>
                                <Box pb="20px" sx={{ width: "calc(100% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                        <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('label.search')}</Typography>
                                        <Typography color="#5DA196" fontSize={16} lineHeight="26.91px" fontWeight={400} >{t("360Evaluation.label.selectedEvaluators")}: {selected.length}</Typography>
                                    </Box>
                                    <Box sx={{ position: "relative" }}>
                                        <TextField
                                            id="searchEmployee"
                                            fullWidth
                                            placeholder={t('360Evaluation.label.searchEmployee')}
                                            size="small"
                                            onFocus={e => handleFocus(true)}
                                            sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                                            className="searchTextField-h40"
                                            autoComplete='off'
                                            onChange={debouncedChangeHandler}
                                        />
                                        <Box sx={{ position: "absolute", width: "100%", zIndex: "9" }}>
                                            <Collapse in={focusSearch}>
                                                <Box sx={{ width: "100%", background: "#FAFAFA", boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", borderRadius: "11px" }} p="39px 39px 25px">
                                                    <Box sx={{ borderBottom: "1px solid #A0A0A0", display: "flex", width: "100%" }} pb="11px" mb="15px">
                                                        <Checkbox
                                                            onClick={(event) => handleClickAll()}
                                                            sx={{ margin: "0 35px 0 0", padding: "0", alignItems: "center" }}
                                                            indeterminate={checkIndeterminate()}
                                                            checked={checkAll()}
                                                        />
                                                        {/* 15.77+20.84+22.49+20.49+20.41 */}
                                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(15.77% - 11.8px)" }} pr="20px">
                                                            <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                {t("360Evaluation.label.employee")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(20.84% - 11.8px)" }} pr="20px">
                                                            <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                {t("360Evaluation.label.name")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                            <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                {t("360Evaluation.label.position")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                            <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                {t("360Evaluation.label.organization")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(16.41% - 11.8px)" }} >
                                                            <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                {t("360Evaluation.label.positionType")}
                                                            </Typography>
                                                            <IconXsearch style={{ cursor: "pointer" }} onClick={handleClose} />
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                                                        {selectSearch.length > 0 ? selectSearch.map((rs, index) => (
                                                            <Box sx={{ display: "flex", width: "100%" }} pb={index + 1 === selectSearch.length ? "0" : "30px"}>
                                                                <Checkbox
                                                                    onClick={(event) => handleClick(rs)}
                                                                    sx={{ margin: "0 35px 0 0", padding: "0", alignItems: "center" }}
                                                                    // onChange={e => changeType(data?.serial)} 
                                                                    checked={checkSelect(rs?.id)}
                                                                />
                                                                {/* 15.77+20.84+22.49+20.49+20.41 */}
                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "calc(15.77% - 11.8px)" }} pr="20px">
                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                        {rs?.code}
                                                                    </Typography>
                                                                </Box>
                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "calc(20.84% - 11.8px)" }} pr="20px">
                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                        {Util.formatData(rs?.first_name, false) + " " + Util.formatData(rs?.last_name, false)}
                                                                    </Typography>
                                                                </Box>
                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                        {rs?.position}
                                                                    </Typography>
                                                                </Box>
                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                        {rs?.organization}
                                                                    </Typography>
                                                                </Box>
                                                                <Box sx={{ display: "flex", flexDirection: "row", width: "calc(16.41% - 11.8px)" }} pr="25px">
                                                                    <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                        {rs?.position_type}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        ))
                                                            :
                                                            <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                                                                <Nodata />
                                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                    {t('360Evaluation.label.noEvaluators')}
                                                                </Typography>
                                                                <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                                    {t('360Evaluation.label.pleaseSearching')}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    </Box>
                                                </Box>
                                            </Collapse>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="30px">
                            <Typography variant="h2" color="#404349" fontSize={30} lineHeight="33px" fontWeight="600">
                                {t("360Evaluation.label.selectedEvaluators")}
                            </Typography>
                            {/* {selected.length > 0 ?
                                <Box sx={{ backgroundColor: "#5DA1961A", padding: "9.05px 20px", borderRadius: "5px" }}>
                                    <Typography color="#5DA196" fontSize={18} lineHeight="26.91px" fontWeight={400} >{t("360Evaluation.label.selectedEvaluators")}: {selected.length}</Typography>
                                </Box>
                                : null
                            } */}
                        </Box>
                        <div className={classes.root}>
                            <Paper className={classes.flexPaper} >
                                <Box
                                    px="40px"
                                >
                                    {formik.values.employees.length > 0 ?
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", flexDirection: "row" }}
                                        >
                                            {/* 18.15 32.2 22.2 17.45 10 */}
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(15.15% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.employee")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(28.2% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.name")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(22.2% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.position")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(22% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.organization")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(12.45% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.positionType")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "75px" }} pl="5px">
                                                <Typography onClick={clearAll} fontSize={16} lineHeight="23.96px" color="#AAAAAA" textAlign='center' fontWeight="400" sx={{ cursor: "pointer", letterSpacing: "-0.02em", textDecorationLine: "underline", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", }}>
                                                    {t("360Evaluation.label.clearAll")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        :
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", flexDirection: "row" }}
                                        >
                                            {/* 18.15 32.2 22.2 17.45 10 */}
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "15.15%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.employee")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "28.2%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.name")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "22.2%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.position")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "22%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.organization")}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "12.45%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {t("360Evaluation.label.positionType")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    }
                                    <Divider width="100%" />
                                </Box>
                                {showLoading ?
                                    <Box sx={{ paddingTop: "87px", display: "flex", alignItems: "center", flexDirection: "column", paddingBottom: "87px" }}>
                                        <Box sx={{ position: 'relative', width: "70px" }}>
                                            <CircularProgress
                                                variant="determinate"
                                                sx={{
                                                    color: "#AAAAAA",
                                                }}
                                                size={70}
                                                thickness={4}
                                                value={100}
                                            />
                                            <CircularProgress
                                                variant="indeterminate"
                                                disableShrink
                                                sx={{
                                                    color: '#5DA196',
                                                    animationDuration: '1000ms',
                                                    position: 'absolute',
                                                    left: 0,
                                                    [`& .${circularProgressClasses.circle}`]: {
                                                        strokeLinecap: 'round',
                                                    },
                                                }}
                                                size={70}
                                                thickness={4}
                                            />
                                        </Box>
                                        <Typography color="#AAAAAA" fontWeight="500" fontSize={16} lineHeight="23.92px" pt="30px">
                                            {t("label.loading") + "..."}
                                        </Typography>
                                    </Box>
                                    :
                                    Util.formatData(items, []).length > 0 ? items.map((row, index) =>
                                        formik.values.employees.length > 0 ? (
                                            <Box px="40px">
                                                <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                                    <Box
                                                        sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", alignItems: "center" }}
                                                        px="25px"
                                                    >
                                                        <Box sx={{ width: "calc(15.15% - 15px)", display: "flex", alignItems: "center" }} pr="15px">
                                                            <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {`${row?.code}`}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "calc(28.2% - 15px)" }} pr="15px">
                                                            <Typography pb={row?.options?.fullname_th !== null && row?.options?.fullname_th !== undefined && row?.options?.fullname_th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.options?.fullname_en !== undefined && row?.options?.fullname_en !== null ? Util.formatData(row?.options?.fullname_en, "") : Util.formatData(row?.fullname, "")}
                                                            </Typography>
                                                            {row?.options?.fullname_th !== null && row?.options?.fullname_th !== undefined && row?.options?.fullname_th !== "" ?
                                                                <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.options?.fullname_th}
                                                                </Typography>
                                                                :
                                                                null
                                                            }
                                                        </Box>
                                                        <Box sx={{ width: "calc(22.2% - 15px)" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.position}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "calc(22% - 15px)" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.organization}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "calc(12.45% - 15px)" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.position_type}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", width: "75px" }} pr="15px">
                                                            <CloseIconLF style={{ cursor: "pointer" }} onClick={e => clearOne(row)} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                        )
                                            :
                                            (
                                                <Box px="40px">
                                                    <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                                        <Box
                                                            sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", alignItems: "center" }}
                                                            px="25px"
                                                        >
                                                            <Box sx={{ width: "15.15%", display: "flex", alignItems: "center" }} pr="15px">
                                                                <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {`${row?.code}`}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: "28.2%" }} pr="15px">
                                                                <Typography pb={row?.options?.fullname_th !== null && row?.options?.fullname_th !== undefined && row?.options?.fullname_th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.options?.fullname_en !== undefined && row?.options?.fullname_en !== null ? Util.formatData(row?.options?.fullname_en, "") : Util.formatData(row?.fullname, "")}
                                                                </Typography>
                                                                {row?.options?.fullname_th !== null && row?.options?.fullname_th !== undefined && row?.options?.fullname_th !== "" ?
                                                                    <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                        {row?.options?.fullname_th}
                                                                    </Typography>
                                                                    :
                                                                    null
                                                                }
                                                            </Box>
                                                            <Box sx={{ width: "22.2%" }} pr="15px">
                                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.position}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: "22%" }} pr="15px">
                                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.organization}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: "12.45%" }} pr="15px">
                                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.position_type}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                    <Divider width="100%" />
                                                </Box>
                                            ))
                                        :
                                        <Box sx={{ paddingTop: "87px", textAlign: "center", paddingBottom: "143px" }}>
                                            <Nodata />
                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                {t('360Evaluation.label.noSelected')}
                                            </Typography>
                                            <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                {t('360Evaluation.label.pleaseSelected')}
                                            </Typography>
                                        </Box>
                                }
                            </Paper>
                        </div>
                    </Box>
                    <Box mt="30px">
                        <Box display="flex" flexDirection="row-reverse">
                            <Box sx={{ width: "100px" }}>
                                <Button color="primary" onClick={submit} variant="contained" fullWidth sx={{ textTransform: "none", }} disabled={selected.length > 0 ? false : true}>
                                    {t('label.add')}
                                </Button>
                            </Box>
                            <Box mr={2} sx={{ width: "100px" }}>
                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none", }}>
                                    {t('label.cancel')}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
            {Util.ScrollToTop()}
            <SimpleDialog
                open={isSuccessAddDialogOpen}
                doDirect={() => handleDirect()}
                setValue={openSuccessAddDialog}
                text={t('360Evaluation.dialog.addEvaluatorSuccessfully')}
                page={true}
            />
            <MessageDialog
                open={openFailedMessageDialog}
                setValue={handleCloseFailedMessageDialog}
                type="fail"
                title={t(`dialog.label.fail`)}
                text={t(`360Evaluation.dialog.addEvaluatorFail`)}
            />
            <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
        </Box>
    );
};
export default AddEvaluator;
